/* unplugin-vue-components disabled */import { render } from "./NetNotice.vue?vue&type=template&id=73b139f4&scoped=true"
import script from "./NetNotice.vue?vue&type=script&lang=js"
export * from "./NetNotice.vue?vue&type=script&lang=js"

import "./NetNotice.vue?vue&type=style&index=0&id=73b139f4&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b139f4"]])

export default __exports__